import { useState, useEffect } from 'react';
import { safeFetch, logError } from '../utils/errorHandler';

const DEFAULT_CONFIG = {
  branding: {
    text: 'Sutra',
    enabled: true
  }
};

/**
 * Config loading hook with loading/error states
 * Automatically sets document.title from config.siteTitle
 * @returns {{ config: object, loading: boolean, error: Error|null }}
 */
export function useConfig() {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    safeFetch('/config.json')
      .then(res => res.json())
      .then(data => {
        setConfig(data);
        if (data.siteTitle) {
          document.title = data.siteTitle;
        }
        setLoading(false);
      })
      .catch(err => {
        logError('useConfig', err);
        setError(err);
        setLoading(false);
      });
  }, []);

  return { config, loading, error };
}
